import {KeyValueObject} from '../_interface/keyValueObject';
import {unflatten} from 'flat';
import {stringToPrimitive} from './stringToPrimitive.fn';
import {BODY_ARRAY_MARKER, OLD_ARRAY_INDEX_DELIMITER} from 'shared/magic';
import {replaceOldDelimiter} from './convertTemplateFields.fn';
import {FieldTypes} from '../_interface/field-types.enum';

export const checkOldDelimiterKey = (str: string) => str.match(new RegExp(OLD_ARRAY_INDEX_DELIMITER, 'g'));
export const keyValueToObject = (input: KeyValueObject[] = [], fieldType: string = null): any => {
	const obj = (input || [])
		.filter(({key}) => key !== BODY_ARRAY_MARKER)
		.map((i) => {
			const { key, value } = i;
			if (checkOldDelimiterKey(key)) {
				if (fieldType === FieldTypes.checkbox) {
					return {key: `${replaceOldDelimiter(key)}`, value};
				}
				return {key: `${replaceOldDelimiter(key)}.key`, value};
			}
			return i;
		})
		.reduce((acc, {key, value}) => ({...acc, ...{[key]: stringToPrimitive(value)}}), {});
	return unflatten(obj);
};

export const itemFromKeyValue = (o: KeyValueObject[] = []): [string, string][] | null => {
	return !o ? null : o.map(({key, value}) => [key, value]);
};

